import axios from "axios";
import { getToken } from "@/utils/auth";
import domMessage from "./messageOnce.js";
import { Message } from "element-ui";
// axios.defaults.withCredentials = false;
// 创建axios实例
var ysq = null;
const messageOnce = new domMessage();
const service = axios.create({
  timeout: 10000,
  retry: 2,
  retryDelay: 5000,
});
// 请求次数
service.defaults.retry = 4;
// 请求间隔
service.defaults.retryDelay = 1000;
service.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Basic c3dvcmQ6c3dvcmRfc2VjcmV0";
    // 配置请求头
    if (getToken()) {
      var loginData = JSON.parse(
        localStorage.getItem("website-userInfo")
      ).content;
      config.headers["Blade-Auth"] = "bearer " + loginData.access_token;
      config.headers["userId"] = loginData.user_id;
      config.headers["Tenant-Id"] = loginData.tenant_id;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    var { msg, code, error_code, error_description } = response.data;
    if (code || error_code) {
      if (code == 401 || error_code == 401) {
        Message({
          message: "请求未授权",
          type: "error",
        });
        return Promise.reject(new Error(msg || error_description));
      }
      if (code !== 200 || (error_code && error_code !== 200)) {
        Message({
          message: msg || error_description || "未知错误",
          type: "error",
        });
        return Promise.reject(new Error(msg || error_description));
      }
    }

    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
